import {Component} from "@angular/core";
import {provideEntityModel, provideReportModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {StockTransferSearchModel} from "../stock-transfer-search.model";
import {StockTransferEntityModel} from "../stock-transfer-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {BatchTransferReportModel} from "../../reports/batch-transfer-report/batch-transfer-report.model";

@Component({
    selector: "wbo-stock-transfer-search-page",
    templateUrl: "./stock-transfer-search-page.component.html",
    providers: [provideSearchModel(StockTransferSearchModel), provideEntityModel(StockTransferEntityModel), provideReportModel(BatchTransferReportModel)]
})
export class StockTransferSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
